import PropTypes from 'prop-types';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import ErrorIcon from '../../../assets/images/ErrorIcon.svg';
import styles from './error-box.module.scss';

const className = augmentClassName(styles);

const ErrorBox = ({ errorMessage }) => {

  return (
    <div {...className('error_message')}>
      <div {...className('error_box_content')}>
        <ErrorIcon /> &nbsp; {errorMessage}
      </div>
    </div>
  );
};

ErrorBox.propTypes = {
  errorMessage: PropTypes.string.isRequired
};

export default ErrorBox;
